<template>
  <div class='main'>
    <div id="query" >
      <p class="title">订单查询</p>
      <input type="text" v-model="certNo" placeholder="请输入身份证号码" maxlength="18">
      <!-- <p class="btn" @click="queryOrder">查询</p> -->
      <van-button style="width: 100%;font-size: 15px;" type="info" @click="queryOrder">查询</van-button>
    </div>
    <popup ref="popupShows"></popup>
    <ajaxLoading ref="loading"></ajaxLoading>
    <maskPopup ref="maskShow"></maskPopup>
  </div>
</template>

<script type="text/ecmascript-6">
import Vue from 'vue';
import popup from '../common/commonComponents/popup';
import ajaxLoading from '../common/commonComponents/loading';
import maskPopup from '../common/commonComponents/maskDiv';

import myInfo from '@/components/order/myInfo';
import {Config, ROUTES} from "../common/api";
import './../common/reset.scss';
import './../common/common';
import {DropdownMenu, DropdownItem ,Search ,Button } from 'vant';
Vue.use(Search);
Vue.use(Button);
Vue.use(DropdownMenu);
Vue.use(DropdownItem);
export default {
  name: "query",
  data() {
    return {
      ajaxState: true, // 防止重复提交，调用多次接口
      certNo: '', // 查询身份证号码452524197811101418
      showFlag: true,
      showOrder:true,
      userInfo: {},
      errorMessage: '',
      searchBank: '', // 搜索银行
      showDropdown: false,
      subBankList:[],
      searchText:'',
    };
  },
  components: {
    popup,
    myInfo,
    ajaxLoading,
    maskPopup,
  },
  mounted() {
    document.title = '订单查询';
  },
  methods: {
    handleSearch(bankSubName){
      if(!bankSubName || bankSubName.length < 2){
          this.showDropdown = false;
          return
      }
      let self = this
      const url = Config.api_url + "applets-server/api/policy/bankQuery";
      // this.loading=true
      this.$ajax({
        method:"post",
        url:url,
        data:{
          bankCode:this.bankCode,
          bankName:this.bankName,
          bankCityName:this.bankCityName,
          bankProvinceName:this.bankProvinceName,
          bankSubName:bankSubName,
        },
        headers: {'Content-Type': 'application/json'}
      }).then(function (res) {
        const data = res.data;
        if (data.success) {
          self.subBankList = data.data.map(itm=>{return {text:itm}})
          self.showDropdown=true
        }else{
          self.subBankList =[{text:'无数据'}]
          self.showDropdown=true
        }
      }).catch(function (err) {
        console.log(err)
        self.showDropdown=false
      });
    },
    // 证件号码校验
    checkIdCard: function (id) {
      if (this.checkScript(id)) {
        this.$refs.popupShows.popupShowing("证件号码包含非法字符");
        return false;
      } else if (!this.idCheck(id)) {
        this.$refs.popupShows.popupShowing("请输入正确的身份证号");
        return false;
      }
      // else if ((/^(81|82|83)/igm).test(id)) {
      //   this.$refs.popupShows.popupShowing("此证件为港澳台居民居住证，暂不能在网络渠道办理业务，请用户到营业厅办理。");
      //   return false;
      // }
      return true;
    },
    // 登录
    queryOrder() {
      let self = this;
      if (!this.checkIdCard(this.certNo)) {
        return;
      }
      if (!this.ajaxState) {
        return;
      }
      this.ajaxState = false;
      const url = Config.api_url + "applets-server/api/policy/order/query";
      this.$refs.loading.loadingFlag = true;

      this.$ajax({
        method: "get",
        url: url,
        withCredentials: false,
        params: {
          certId: this.certNo,
        },
        headers: {'Content-Type': 'application/x-www-form-urlencoded'}
      }).then(function (res) {
        self.ajaxState = true;
        const data = res.data;
        if (data.success) {
          self.userInfo = data.data;
          self.errorMessage = data.data.errorMessage || '';
          localStorage.setItem('infoToken', data.data.token);
          localStorage.setItem('bdOrderInfo', JSON.stringify(data.data));
          self.$router.push('/myOrder/'+self.certNo);
        } else {
          self.$refs.popupShows.popupShowing(data.errorMessage);
        }
        self.$refs.loading.loadingFlag = false;
      }).catch(function (err) {
        self.ajaxState = true;
        self.$refs.loading.loadingFlag = false;
        self.$refs.popupShows.popupShowing('网络异常，请重试！');
      });
    },
    // 申请补偿
    toClaim() {
      if (this.errorMessage) {
        this.$refs.popupShows.popupShowing(this.errorMessage);
        return;
      }
      this.$router.push('/applyClaim');
    }
  },
  watch: {},
};
</script>

<style lang="scss" scoped>
$them: #067adc;
* {
  margin: 0;
  padding: 0;
}

.main {
  padding-bottom: 50px;
  overflow: hidden;
  #query {
    padding: 90px 50px;
    .title {
      line-height: 40px;
      font-size: 20px;
      color: #151515;
    }
    input {
      margin-top: 26px;
      width: 100%;
      display: block;
      font-size: 15px;
      height: 35px;
      padding: 7px 0;
      box-sizing: border-box;
      border-top: none;
      border-left: none;
      border-right: none;
      border-bottom: 1px solid #eeeeee;
    }
    .btn {
      width: 100%;
      font-size: 15px;
      text-align: center;
      color: #fff;
      line-height: 45px;
      background: #2486ff;
      border-radius: 4px;
      margin-top: 25px;
    }
  }
  #detail {
    width: 355px;
    margin: 0 auto;
    overflow: hidden;
    border-radius: 8px;
    ul {
      overflow: hidden;
      border-bottom: 1px solid #eeeeee;
      padding-bottom: 26px;
      li {
        display: flex;
        overflow: hidden;
        padding: 7px 15px;
        line-height: 20px;
        font-size: 15px;
        .spanL {
          float: left;
          color: #1b1b1b;
        }
        .spanR {
          flex: 1;
          text-align: right;
          padding-left: 10px;
          color: #999;
        }
      }
    }
    .btn {
      padding: 15px;
      span {
        display: block;
        font-size: 15px;
        text-align: center;
        color: #fff;
        line-height: 45px;
        background: #2486ff;
        border-radius: 4px;
        margin-top: 25px;
      }
    }
  }

}

.popup {
  width: 100%;
  padding: 0 0.75rem;
  background-color: transparent;
  z-index: 1003;
  box-sizing: border-box;
  position: fixed;
  top: 50%;
  left: 50%;
  -moz-transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
}


.user-info-note {
  font-size: 0.75rem;
  color: rebeccapurple;
}
</style>



// WEBPACK FOOTER //
// orderQuery.vue?4461fc9e